// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__YdlhN","split-65":"Grid_split-65__0JYZA","split":"Grid_split___3_Hg"};